import { render } from "./sipTemplate.vue?vue&type=template&id=c7384ace&scoped=true"
import script from "./sipTemplate.vue?vue&type=script&lang=js"
export * from "./sipTemplate.vue?vue&type=script&lang=js"

import "./sipTemplate.vue?vue&type=style&index=0&id=c7384ace&scoped=true&lang=css"
import "./sipTemplate.vue?vue&type=style&index=1&id=c7384ace&lang=css"
script.render = render
script.__scopeId = "data-v-c7384ace"

export default script